<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">Unternehmen</h1>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-two-thirds">
          <HeroSlider :slides="slides" :heightFirst="true" />
        </div>
        <div class="column is-one-third">
          <SalesContainer :config="salesContainerConfig" />
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <h2 class="SubPage__subHeading">{{ subHeading }}</h2>
      <NewsList :config="listConfig" />
    </div>
    <Footer />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import HeroSlider from "../HeroSlider/HeroSlider";
import SalesContainer from "../SalesContainer/SalesContainer";
import PageHeader from "../PageHeader/PageHeader";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer";
import NewsList from "../NewsList/NewsList";

export default {
  name: "NewsListPage",
  components: {
    Breadcrumbs,
    Footer,
    HeroSlider,
    SalesContainer,
    PageHeader,
    CookieDisclaimer,
    NewsList
  },
  props: {
    subHeading: {
      type: String,
      default: ""
    },
    listConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cookieDisclaimerConfig: {
        text:
          "Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.",
        link: {
          text: "Weitere Informationen",
          url: "#"
        },
        button: {
          text: "Zustimmen",
          colour: "blue"
        }
      },
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Unternehmen",
          url: "#"
        },
        {
          title: "Neuheiten & Messen",
          url: "#"
        },
        {
          title: "Medien",
          url: "#"
        }
      ],
      slides: [
        {
          image: "https://picsum.photos/662/257?random=1",
          newWindow: false,
          url: "#"
        },
        {
          image: "https://picsum.photos/662/257?random=2",
          newWindow: false,
          url: "#"
        },
        {
          image: "https://picsum.photos/662/257?random=3",
          newWindow: false,
          url: "#"
        }
      ],
      salesContainerConfig: {
        title: "Vertriebskontakt",
        text: "Fragen? Finden Sie Ihren Ansprechpartner im WIKA-Vertriebsteam.",
        icon: "fas fa-user-tie",
        input: {
          placeholderText: "Postleitzahl eingeben",
          submitUrl: "contact_de_at.WIKA?cnType=1&cnEntry="
        },
        buttons: [
          {
            icon: "far fa-comments",
            text: "Jetzt chatten",
            offlineText: "Nachricht senden"
          },
          {
            icon: "fas fa-envelope",
            text: "Kontaktformular",
            linkUrl: "#"
          }
        ]
      }
    };
  }
};
</script>
